import { A04, A04Input, A04Output } from 'api/U015';
import { useCallback, useState } from 'react';

type UpdateConsentDoRequest = (param: {
  request: A04Input;
  onSuccess?: (response: A04Output) => void;
  onError?: (err: Error) => void;
  cancellation?: AbortSignal;
}) => void;

export function useUpdateConsentHooks(): [UpdateConsentDoRequest, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(false);
  const [err, setError] = useState<Error | null>(null);

  const updateConsent = async (request: A04Input, cancellation: AbortSignal) => {
    return await A04(request, cancellation);
  };

  const doRequest = useCallback<UpdateConsentDoRequest>(
    async ({ request, cancellation, onSuccess, onError }) => {
      const controller = new AbortController();
      const cancelSignal = cancellation ?? controller.signal;
      try {
        setLoading(true);
        const consent = await updateConsent(request, cancelSignal);
        onSuccess?.(consent);
      } catch (err) {
        console.error(err);
        const flooredError = err instanceof Error ? err : new Error(`unknown error. ${err}`);
        onError?.(flooredError);
        setError(flooredError);
      } finally {
        setLoading(false);
      }
    },
    [updateConsent, setLoading, setError]
  );

  return [doRequest, loading, err];
}
